import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom'
import { useLocation } from 'react-router-dom';

const CustomBreadCrumb = styled(Link)(({ theme }) => {
  return {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: 15,
    transition: "0.2s",
    '&:hover, &:focus': {
      color: theme.palette.primary.main,
      textDecoration: "none",
      fontWeight: theme.typography.fontWeightMedium
    }
  };
}) as typeof Link;

const BreadCrumbCurrent = styled(Typography)(({ theme }) => {
  return {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 15
  };
}) as typeof Typography;

const breadcrumbNameMap: { [key: string]: string } = {
  '/demonstration': 'Demonstration',
  '/headings': 'Headings'
};

export function BreadCrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <Breadcrumbs separator={<FontAwesomeIcon icon={faAngleRight} size="xs" />} sx={theme => {return {color: theme.palette.grey[400],fontSize: 15}}} aria-label="breadcrumb">
      <CustomBreadCrumb underline="hover" color="inherit" href="/">
        Customer Portal
      </CustomBreadCrumb>
      {pathnames.length < 1 ? 
        <BreadCrumbCurrent>
          Customer Bulletin
        </BreadCrumbCurrent>
        :
        <CustomBreadCrumb underline="hover" color="inherit" href="/customer-bulletin">
          Customer Bulletin
        </CustomBreadCrumb>
      }

      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join('/')}`

        const breadcrumbText = breadcrumbNameMap[to] !== undefined && breadcrumbNameMap[to] !== "" ? breadcrumbNameMap[to] : pathnames[index];

        return last ? (
          <BreadCrumbCurrent key={to}>
            {breadcrumbText}
          </BreadCrumbCurrent>
        ) : (
          <CustomBreadCrumb key={to} underline="hover" color="inherit" to={to} component={RouterLink}>
            {breadcrumbText}
          </CustomBreadCrumb>
        )
      })}
    </Breadcrumbs>
  )
}